import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@material-ui/core';
import React from 'react';
import { useSelector } from 'react-redux';
import { allUIBuilderHotelModuleOptionsSelector } from '../../../layouts/property/propertySlice';

const HotelModuleSelector = (props) => {
  const {
    hotelModule,
    onChangeHotelModule,
    disabled,
    hideNullOption,
    nullOptionLabel,
    error,
    required,
  } = props;
  const hotelModuleOptions = useSelector(allUIBuilderHotelModuleOptionsSelector);

  const onChange = (e) => {
    const hotelModuleName = hotelModuleOptions.find(
      (hotelModule) => hotelModule.id === e.target.value,
    );
    onChangeHotelModule(e.target.value, hotelModuleName?.label);
  };
  return (
    <FormControl className='w-100' error={error} required={required}>
      <InputLabel id='hotel-module-'>Hotel Module</InputLabel>
      <Select
        disabled={disabled}
        labelId='hotel_module_label'
        id='hotel_module_select'
        autoWidth={false}
        value={hotelModule}
        onChange={(e) => {
          onChange(e);
        }}
        MenuProps={{
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
          getContentAnchorEl: null,
        }}
      >
        {!hideNullOption && (
          <MenuItem value=''>
            <em>{nullOptionLabel || 'None'}</em>
          </MenuItem>
        )}

        {hotelModuleOptions.map((item, key) => {
          return (
            <MenuItem key={key} value={item?.id}>
              {item?.label}
            </MenuItem>
          );
        })}
      </Select>
      <FormHelperText>{error ? 'Hotel Module required' : ''}</FormHelperText>
    </FormControl>
  );
};

export default HotelModuleSelector;
